export default "__VITE_ASSET__CWoGDfgX__"